import firedux from '../firedux'
import {dispatch} from '../store'
import {fromJS} from 'immutable'

import {
  GROUP_CHAT_BOOKMARKS_ENDPOINT
} from '../../config/constants'

import setBookmarkedGroups from '../actions/set_bookmarked_groups'
import removeBookmarkedGroup from '../actions/remove_bookmarked_group'
import getGroupChat from '../getters/group_chat'

const onBookmarkedGroups = (snapshot) => {
  let groups = snapshot.val()

  if (!groups) return dispatch(setBookmarkedGroups(groups))

  groups = fromJS(groups)
    .map((_, key) => getGroupChat(key))

  Promise.all(groups.toList().toJS())
    .then((groups) => dispatch(setBookmarkedGroups(groups)))
}

const onBookmarkedGroupRemoved = (snapshot) => {
  const key = snapshot.key()

  dispatch(removeBookmarkedGroup(key))
}

export const watchBookmarkedGroups = (uid) => {
  if (!uid) return Promise.reject()

  const ref = firedux.ref.child(GROUP_CHAT_BOOKMARKS_ENDPOINT).child('users').child(uid)

  ref.on('value', onBookmarkedGroups)
  ref.on('child_removed', onBookmarkedGroupRemoved)
}

export const unwatchBookmarkedGroups = (uid) => {
  if (!uid) return Promise.reject()

  const ref = firedux.ref.child(GROUP_CHAT_BOOKMARKS_ENDPOINT).child('users').child(uid)

  ref.off('value', onBookmarkedGroups)
  ref.off('child_removed', onBookmarkedGroupRemoved)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/bookmarked_group_chats.js
 **/